

export type RoutingInfo = {
  id: string;
  agentId: string;
  teamName: string;
  teamId: string;
  associateIntents: string[];
};


export function routingInfoToLocal(res: any): RoutingInfo {

  return {
    id: res.id,
    agentId: res.agent_id,
    teamName: res.team_name,
    teamId: res.team_id,
    associateIntents: res.associate_intents
  };
}

export function routingInfoToServer(data: RoutingInfo): any {
  const payload: any = {
    id: data.id,
    agent_id: data.agentId,
    team_name: data.teamName,
    team_id: data.teamId,
    associate_intents: data.associateIntents
  };

  if (!payload.id || payload.id === '') {
    delete payload.id;
  }

  return payload;
}
